var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenaliteRugby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.41px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 91.99,
    x2: 54.37,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 95.63,
    y1: 91.99,
    x2: 95.63,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.87,
    y: 75.8,
    width: 7.52,
    height: 16.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.61,
    y: 75.8,
    width: 7.52,
    height: 16.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.37,
    y1: 67.92,
    x2: 95.63,
    y2: 67.92
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.44,28.64h9.63c2.1,0,3.67.5,4.71,1.5,1.04,1,1.57,2.42,1.57,4.26s-.57,3.37-1.71,4.44c-1.14,1.07-2.88,1.6-5.21,1.6h-3.17v6.96h-5.82v-18.75ZM73.26,36.64h1.42c1.12,0,1.9-.19,2.35-.58.45-.39.68-.88.68-1.49s-.2-1.09-.59-1.5c-.39-.41-1.13-.61-2.21-.61h-1.65v4.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaliteRugby);
export default __webpack_public_path__ + "static/media/Penalite_rugby.2e7f2095feb8d426cb32618e68ce25d0.svg";
export { ForwardRef as ReactComponent };